var site = site || {};

site.defaultCountry = site.defaultCountry || {};

(function ($) {
  Drupal.behaviors.csContactFormV1 = {
    /**
     * Flag to ensure this JS is only attached once.
     * @type {boolean}
     */
    attached: false,

    /**
     * Hides the thank you section of the form.
     */
    hideItems: function () {
      $('.js-cs-contact-form-thanks').addClass('hidden');
    },

    /**
     * Sends out an RPC call for the contact form.
     */
    submitContactForm: function (event) {
      event.preventDefault();

      var $contactForm = $('.js-cs-contact-form');
      var $contactFormErrors = $('.js-cs-contact-form-errors');
      // Loading Button
      var enableLoading = $('.js-loading-message', $contactForm).length ? true : false;
      var $btnElements = $('.js-loading-message, .js-contact-submit', $contactForm);

      if (enableLoading) {
        $btnElements.toggleClass('hidden');
      }

      // Reset all input fields display.
      $('input,label,select,textarea,[name=QUESTION]', $contactForm).removeClass('error');

      // Put the form values into an object.
      var parametersArray = $contactForm.serializeArray();
      var parametersObject = {};

      $.each(parametersArray, function (index, param) {
        parametersObject[param.name] = param.value;
      });

      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [parametersObject],
        onSuccess: function (jsonRpcResponse) {
          $contactFormErrors.hide();
          $('.js-cs-contact-form-thanks').removeClass('hidden');
          $('.js-cs-contact-form-call').addClass('hidden');
          $('.js-legal-frame')?.addClass('hidden');
          $contactForm.hide();
          var linktest = $('.site-content');

          $('html, body').animate({
            scrollTop: $(linktest).offset().top
          }, 800);
        },
        onFailure: function (jsonRpcResponse) {
          // Get errors back and build a set of list items to inject into the HTML.
          var errorObjectsArray = jsonRpcResponse.getMessages();
          var errorHTML = '';

          if (enableLoading) {
            $btnElements.toggleClass('hidden');
          }

          var ordering = [
            'required.question.contact_us',
            'required.first_name.contact_us',
            'required.last_name.contact_us',
            'required.email_address.contact_us'
          ];

          for (var i = 0; i < errorObjectsArray.length; i++) {
            errorHTML += '<li>' + errorObjectsArray[i].text + '</li>';

            // Use the jsonRpcResponse key to pair with input nodes.
            // Error keys are returned as "required.**FIELD**.**FORM**".
            // Match the **FIELD** in a javascript match.
            var fieldName = errorObjectsArray[i].key ? errorObjectsArray[i].key.match(/\w*.(\w*)./) : '';

            // Check if there is a match.
            if (fieldName && fieldName[1]) {
              // If match, get the matching input nodes to add the error class.
              var $node = $('[name=' + fieldName[1].toUpperCase() + ']', $contactForm);

              $node.addClass('error');
            }
          }
          $contactFormErrors.html(errorHTML).show();
          generic.errorOrder(errorObjectsArray, $('.js-cs-contact-form-errors'), ordering, contact_us);
          generic.focusErrors($('.js-cs-contact-form-errors'));
          generic.focusErrors($('.js-cs-contact-form-errors'), $('.js-cs-contact-form'));

          // Scroll the page to top of error list node adjusting for the nav.
          var errorsPosition = $contactFormErrors.position();
          var scrollTop = errorsPosition && errorsPosition.top ? errorsPosition.top + $('.site-header').height() : '';

          $('html, body').animate({
            scrollTop: scrollTop
          }, 1000);
        }
      });
    },

    /**
     * Sets up events for this template.
     * @param {Object} context - the DOM scope, usually document.
     */
    setEvents: function (context) {
      $('.js-cs-contact-form').on('submit', this.submitContactForm);
    },

    /**
     * Calls all methods for setting up this template's JS.
     * @param {Object} context - the DOM scope, usually document.
     */
    init: function (context) {
      var self = this;

      $('.cs-contact-forms-v1', context).each(function () {
        self.hideItems();
        self.setEvents(context);
      });
    },

    /**
     * Standard method for attaching the template's JS.
     * @param {Object} context - the DOM scope, usually document.
     * @param {Object} settings - useful collection of site info.
     */
    attach: function (context, settings) {
      if (this.attached) {
        return;
      }
      this.attached = true;
      this.init(context);
    }
  };
})(jQuery);
